import { render, staticRenderFns } from "./Franchise.vue?vue&type=template&id=d191e9b6"
import script from "./Franchise.vue?vue&type=script&lang=js"
export * from "./Franchise.vue?vue&type=script&lang=js"
import style0 from "./Franchise.vue?vue&type=style&index=0&id=d191e9b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports